import { z } from 'zod';
import { linkSchema, LinkTypeSchema } from './commons';
export var TeleservicesTypesEnum;
(function (TeleservicesTypesEnum) {
    TeleservicesTypesEnum["CONTRIBUTION_INFORMATION"] = "contributionInformation";
})(TeleservicesTypesEnum || (TeleservicesTypesEnum = {}));
// Base Workflow config
const BaseWorkflowPageSchema = z.object({ actif: z.boolean() });
const BasePagePropertySchema = z.object({ required: z.boolean(), hidden: z.boolean() });
// Contribution information pages
const DisplayConfigSchema = z.object({
    allowDemandeurs: z.boolean().optional(),
    allowIntervenants: z.boolean().optional(),
    conditionMasquage: z.string().optional(),
});
const PageContributionInformationSchema = BaseWorkflowPageSchema.extend({
    typesInformation: z.array(LinkTypeSchema),
    date: BasePagePropertySchema,
    type: BasePagePropertySchema,
    motif: BasePagePropertySchema,
    commentaire: BasePagePropertySchema,
});
// Workflows
export const WorkflowSchema = z.object({
    pagePreambule: BaseWorkflowPageSchema.optional(),
    pagePieces: BaseWorkflowPageSchema.optional(),
    pageRecapitulatif: BaseWorkflowPageSchema.optional(),
    pageConfirmation: BaseWorkflowPageSchema.optional(),
});
export const ContributionInformationWorkflowSchema = z.object({
    type: z.literal(TeleservicesTypesEnum.CONTRIBUTION_INFORMATION),
    contributionInformation: WorkflowSchema.extend({
        display: DisplayConfigSchema.optional(),
        pageContributionInformation: PageContributionInformationSchema.optional(),
    }),
});
// Teleservice
export var TeleservicesStatut;
(function (TeleservicesStatut) {
    TeleservicesStatut["BROUILLON"] = "BROUILLON";
    TeleservicesStatut["PUBLIE"] = "PUBLIE";
    TeleservicesStatut["DESACTIVE"] = "DESACTIVE";
})(TeleservicesStatut || (TeleservicesStatut = {}));
export const TeleserviceSchema = z.object({
    id: z.string(),
    reference: z.string(),
    title: z.string(),
    statut: z.nativeEnum(TeleservicesStatut),
    workflow: z.discriminatedUnion('type', [ContributionInformationWorkflowSchema]),
});
export const ListTeleserviceResponseSchema = z.object({
    _embedded: z.object({
        items: z.array(TeleserviceSchema.pick({
            id: true,
            reference: true,
            title: true,
            statut: true,
        })),
    }),
    count: z.number(),
    total: z.number(),
    _links: z
        .object({
        next: linkSchema.optional(),
    })
        .optional(),
});
// Teleservice translation (referentiel-ressources)
const FieldConfigSchema = z.object({
    label: z.string(),
    help: z.string(),
});
export const TeleserviceTranslationSchema = z.object({
    teleservice: z.object({
        preambule: z.object({
            title: z.string(),
            'information-header': z.string().optional(),
            content: z.string().optional(),
        }),
        information: z
            .object({
            title: z.string(),
            'information-header': z.string().optional(),
            date: FieldConfigSchema,
            type: FieldConfigSchema,
            motif: FieldConfigSchema,
            commentaire: FieldConfigSchema,
        })
            .optional(),
        pieces: z.object({
            title: z.string(),
            'information-header': z.string().optional(),
        }),
        recapitulatif: z.object({
            title: z.string(),
            'information-footer': z.string().optional(),
            contenuHtml: z.string().optional(),
            acceptationCGU: z.object({
                label: z.string(),
                error: z.object({
                    required: z.string(),
                }),
            }),
        }),
        confirmation: z.object({
            title: z.string(),
            recapitulatif: z.string().optional(),
        }),
    }),
});
//# sourceMappingURL=teleservice.js.map